<template>
  <PageLoadMore v-if="state.article" :data="state.article" />
</template>

<script setup lang="ts">
import useArticle from '~/composables/useArticle';
import type { TArticle, TArticleType } from '~~/types/local_types';

const articleType: TArticleType = 'artikelen';

interface IState {
  article?: TArticle;
  variant: string;
  redirectChecked?: boolean;
}
const state: IState = reactive({
  variant: useIsChildPageOf(),
});

state.article = await useArticle(articleType);
if (state.article && state.article?.slug) {
  state.redirectChecked = await useCheckRedirect(
    state.article.slug,
    state.article.articleType,
    state.article.externalUrl,
  );
  const metaObject = usePageSeo({ content: state.article }); // Set SEO meta tags
  if (import.meta.client) {
    const { splitType } = formatUtils();
    const { chapter1, chapter2 } = splitType(state?.article?.articleType);
    sendAnalytics({
      prefix: state?.article?.articleType,
      chapter1,
      chapter2,
      slug: state?.article?.slug,
      metaObject,
    });
  }

  onMounted(() => {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
  });
}
</script>

<style scoped lang="postcss"></style>
